import { gameLogger } from '../../utils/GameLogger';

export type MultiplayerDiagnosticLevel = 'debug' | 'info' | 'warn' | 'error';

export interface MultiplayerDiagnosticPayload {
  [key: string]: unknown;
}

export function logMultiplayerDiagnostic(
  level: MultiplayerDiagnosticLevel,
  event: string,
  payload: MultiplayerDiagnosticPayload = {},
): void {
  const message = `[MP_DIAG] ${event}`;
  const data = {
    kind: 'multiplayer_diagnostic',
    event,
    ...payload,
  };

  switch (level) {
  case 'debug':
    gameLogger.debug('multiplayer_diag', message, data);
    return;
  case 'warn':
    gameLogger.warn('multiplayer_diag', message, data);
    return;
  case 'error':
    gameLogger.error('multiplayer_diag', message, data);
    return;
  default:
    gameLogger.info('multiplayer_diag', message, data);
  }
}
